import Swiper, { Navigation, Pagination } from "swiper";
import {
  isFavorite,
  addFavoriteItem,
  removeFavoriteItem,
} from "@src/utils/favorite";

import "./index.css";

export function setupNearby() {
  const container = document.querySelector(".container-nearby");

  if (container == null) {
    return;
  }

  new Swiper(".container-nearby-swiper", {
    slidesPerView: "auto",
    spaceBetween: 24,
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // set favorite
  const favorites = container.querySelectorAll(
    ".container-nearby-item-favorite"
  ) as NodeListOf<HTMLButtonElement>;
  favorites.forEach((favorite) => {
    const propertyId = favorite.getAttribute("data-property-id") || "";
    favorite.setAttribute("data-favorite", isFavorite(propertyId).toString());
  });

  // toggle favorite
  container.addEventListener("click", (event) => {
    if (event.target instanceof HTMLElement) {
      const btn = event.target.closest(".container-nearby-item-favorite");
      const propertyId = btn?.getAttribute("data-property-id");
      if (btn && propertyId) {
        if (btn.getAttribute("data-favorite") === "true") {
          // remove from favorite
          btn.setAttribute("data-favorite", "false");
          removeFavoriteItem(propertyId);
        } else {
          // add to favorite
          btn.setAttribute("data-favorite", "true");
          addFavoriteItem(propertyId);
        }
      }
    }
  });
}
